export const OptionTurnosData = [
  {
    title: "Buscador Turnos",
    icon: "SearchIcon",
    link: "/buscadorTurnos",
    subMenuItems: [],
    key: 22
  },
  {
    title: "Consultas Médicas",
    icon: "ConsultaIcon",
    link: "/consultamedica",
    subMenuItems: [],
    key: 0
  },
  {
    title: "Estudios",
    icon: "EstudioIcon",
    link: "estudios",
    subMenuItems: [],
    key: 1
  },
  {
    title: "Laboratorio",
    icon: "LaboratorioIcon",
    link: "laboratorio",
    subMenuItems: [],
    key: 2
  },
  {
    title: "Recetas digitales",
    icon: "RecetaDigitalIcon",
    link: "/recetasDigitales",
    subMenuItems: [],
    key: 3
  },
  {
    title: "Próximos turnos",
    icon: "MiTurnoIcon",
    link: "/proximosTurnos",
    subMenuItems: [],
    key: 4
  },
  {
    title: "Video consulta",
    icon: "VideoConsultaIcon",
    link: "/proximosTurnos",
    subMenuItems: [],
    key: 5
  },
  {
    title: "Atención sin turno",
    icon: "AtencionSinTurnoIcon",
    link: "/atencionSinTurno",
    subMenuItems: [],
    key: 6
  },
  {
    title: "Test PCR (COVID-19)",
    icon: "TestPcrIcon",
    link: "/laboratorio",
    subMenuItems: [],
    key: 7
  },
  {
    title: "Oncología",
    icon: "OncologiaIcon",
    link: "/oncologia",
    subMenuItems: [],
    key: 8
  },
  {
    title: "Ordenes digitales",
    icon: "OrdenesDigitalesIcon",
    link: "/ordenesdigitales",
    subMenuItems: [],
    key: 9
  },
];
